import styled from '@emotion/styled'
import { css } from '@emotion/css'

export const RangeInputWrapper = styled.div`
  width: 100%;
`
export const RangeInputStyle = css`
  height: 32px !important;
`
